<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>FUEL REPORT</h4>
			</div>

			<div class="col-md-12 mb-3 position-relative">
				<el-button v-if="showLeftButton" size="medium" class="nav-button-tab left ml-2" @click="scrollLeft">
					<i class="fa fa-chevron-left"></i>
				</el-button>


                    <div id="container-btn-tab-fuel-report" class="scrollable-row" :class="{ 'with-left-button': showLeftButton, 'with-right-button': showRightButton }" ref="scrollContainer">
                        <el-button
                            v-for="(item, index) in tabList"
                            :key="'btn-tab-'+index"
                            :type="tabIndex === item.index ? 'primary' : 'plain'"
                            size="medium"
                            @click="selectTab(item.index)"
                        >
                            <i class="fa fa-angle-down"></i> &nbsp; {{ item.label }}
                        </el-button>
                    </div>


				<el-button v-if="showRightButton" size="medium" class="nav-button-tab right mr-2" @click="scrollRight">
					<i class="fa fa-chevron-right"></i>
				</el-button>
			</div>

			<div class="col-md-12 mb-3" v-if="false">
				<el-row class="scrollable-row">
					<el-button :type="tabIndex == item.index ? 'primary' : 'plain'" class="" size="medium" v-for="(item, index) in tabList" :key="'btn-tab-'+index" @click="selectTab(index)"> <i class="fa fa-angle-down"></i> &nbsp; {{ item.label }}</el-button>
				</el-row>
			</div>

			<div class="col-md-12 mb-2">
				<el-card shadow="never" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
					<div>
						<div v-for="(item, index) in tabList" :label="item.label" :name="item.index" :key="index" >
							<FuelReportTab v-show="tabIndex == item.index" :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label" :showTitle="true"/>
						</div>
					</div>
				</el-card>
			</div>

			<div class="col-md-12" v-if="false">
				<el-card shadow="never" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div>
						<div class="mb-0 px-2" style="margin-top:0px;">
							<el-tabs v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<FuelReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import FuelReportTab from '@/views/pages/FuelReportTab.vue'

export default
{
	extends: Bright,
	components: {
		FuelReportTab,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0',
			tabList:[
				{label:'Sales', name: 'sales', index: '0' },
				{label:'Losses', name: 'losses', index: '1' },
				{label:'Payment', name: 'payment', index: '2' },
				{label:'Stock', name: 'stock', index: '3' },
				//{label:'Growth By Month', name: 'growth_by_month', index: '4' },
				//{label:'Growth By Year', name: 'growth_by_year', index: '5' },
				//{label:'Sales Contribution', name: 'sales_contribution', index: '6' },
				//{label:'RKAP vs Realisasi', name: 'rkap_vs_realisasi', index: '7' },
				{label:'Growth Outlet', name: 'outlet', index: '8' },
				{label:'Hose Delivery', name: 'hose_delivery', index: '9' },
				{label:'Grading Pertamina Way', name: 'grading_station', index: '10' },
				//{label:'Summary Grading Pertamina Way', name: 'grading_station_summary', index: '11' },
				{label:'Margin TAC', name: 'margin_tac', index: '12' },
				{label:'ATG Online', name: 'atg_online', index: '13' },
				{label:'EDC Detail', name: 'edc_detail', index: '14' },
			],

			showLeftButton: false,
			showRightButton: false
		}
	},
	watch: {
		//area() { this.resumePilihan() },
	},
    mounted() {
        this.$emit('childrenRoute');
		this.checkOverflow();
        window.addEventListener('resize', this.checkOverflow);
    },
	beforeDestroy() {
		window.removeEventListener('resize', this.checkOverflow);
	},
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

		selectTab(index) {
			this.tabIndex = `${index}`; //String(index);
			//console.log('index: ' + index);
		},

		checkOverflow() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const container = document.getElementById('container-btn-tab-fuel-report');  //const container = this.$refs.scrollContainer;
                    if (container) {
                        this.showLeftButton = container.scrollLeft > 0;
                        //this.showRightButton = container.scrollLeft + container.clientWidth < container.scrollWidth;
                        this.showRightButton = Math.ceil(container.scrollLeft + container.clientWidth) < container.scrollWidth;

                        //this.showRightButton = container.scrollLeft + container.clientWidth < container.scrollWidth;
                        //this.showRightButton = container.scrollWidth > container.clientWidth + container.scrollLeft;

                        //console.log('this.showLeftButton: ' + this.showLeftButton);
                        //console.log('this.showRightButton: ' + this.showRightButton);
                        //console.log('container.scrollLeft: ' + container.scrollLeft);
                        //console.log('container.clientWidth: ' + container.clientWidth);
                        //console.log('container.scrollWidth: ' + container.scrollWidth);
                        //console.log('Math.ceil: ' + Math.ceil(container.scrollLeft + container.clientWidth));
                    }
                }, 100);
            });
        },
        scrollLeft() {
            this.$nextTick(() => {
                this.sideScroll('left', 25, 100, 120);
            });
        },
        scrollRight() {
            this.$nextTick(() => {
                this.sideScroll('right', 25, 100, 120);
            });
        },
        sideScroll(direction, speed, distance, step) {
            let scrollAmount = 0;
            this.$nextTick(() => {
                const container = document.getElementById('container-btn-tab-fuel-report');  //this.$refs["scrollContainer"];
                if (!container) return;

                const slideTimer = setInterval(() => {
                    if (direction === 'left') {
                        container.scrollLeft -= step;
                    } else {
                        container.scrollLeft += step;
                    }

                    scrollAmount += step;
                    if (scrollAmount >= distance) {
                        clearInterval(slideTimer);
                    }

                    this.checkOverflow();
                }, speed);
            });
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.scrollable-row {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  max-width: 100%;
  padding: 5px 0px;
  scroll-behavior: smooth;
}

.scrollable-row::-webkit-scrollbar {
  display: none;
}
.scrollable-row {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scroll-container.with-nav-buttons {
  margin-left: 40px;
  margin-right: 40px;
}

.scrollable-row.with-left-button {
  margin-left: 40px;
}

.scrollable-row.with-right-button {
  margin-right: 40px;
}

.position-relative {
  position: relative;
}
.nav-button-tab {
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    z-index: 10;
    /*

    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    */
    padding-left: 10px !important;
    padding-right: 10px !important;
}
.nav-button-tab.left {
  left: 0px;
}
.nav-button-tab.right {
  right: 0px;
}
</style>
